module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Foamcore_MockedUp.b11fe7c0.jpg";